





































import { QVueGlobals } from 'quasar';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import LayerSelector from '@/components/LayerSelector.vue';
import LockboxDateRange from '@/components/LockboxDateRange.vue';
import CountChart from '@/components/CountChart.vue';
import CountHeatmapChart from '@/components/CountHeatmapChart.vue';
import EsriLegend from '@/components/EsriLegend.vue';
import TransactionTotal from '@/components/TransactionTotal.vue';
import Map from '@/components/EsriMapHeatmap.vue';

@Component({
  components: {
      LockboxDateRange,
      CountChart,
      CountHeatmapChart,
      LayerSelector,
      EsriLegend,
      TransactionTotal,
      Map,
    },
})
export default class LayoutDefault extends Vue {

  public layerMenuShowing = false;

  public unsubscribe = this.$store.subscribeAction((action, state) => {
      if (action.type === 'notify') {
          this.notify(action.payload);
      }
  });

  public notify(message: any) {
    this.$q.notify(message);
  }

  public mounted() {
    console.log('App: mounted()');
  }

}
